export const delayWrapper = <T>(promise: Promise<T>) => {
  // TODO: temporarely disabled for INP tests. Delete delayWrapper if remains commented
  // return new Promise((resolve) => {
  //   setTimeout(resolve);
  // }).then(() => promise);

  return promise;
};
